    import { useState, useEffect,useRef,useContext} from 'react';
    import '../assets/css/views/recargas.css'
    import { useModal } from '../hooks/useModal'
    import { useSpinner } from '../hooks/useSpinner'
    import { AuthFetch, AuthFetchRecharge } from '../services/api'
    import { formatDate, notify, obtenerHoraActual } from '../utils/utils'
    import imagenDefault from '../assets/images/sinImagen.PNG'
    import { UserContext } from "../context/provider/UserProvider";
    
    // const urlBase = process.env.REACT_APP_BEEDRONE_WEB_API;
    const urlMinio = process.env.REACT_APP_BEEDRONE_WEB_API_MINIO


    export const useRecargas = () => {
        const { stateUser , signOut } = useContext(UserContext);
        const [ fotoRecarga, setFotoRecarga ] = useState(imagenDefault);

        const recargaDefault = {
                codPeticion: 0,
                fechaOCR: '',
                fechaHoraCreacion: '',
                codUsuario: 0,
                correoPrincipal: '',
                nomPersona: '',
                apePersona: '',
                numeroDocumento: '',
                numCelularPrincipal: '',
                codEntidadBancariaCuenta: 0,
                nomEntidadBancaria: '',
                comentario: '',
                montoOCR: 0,
                numeroOperacionOCR:0,            
                nomEstado: '',
                codEstado: 0,
                nomUsuario: '',
                nomVoucher: '',
                nomCarpetaVoucher: '',
                fechaHoraFin:'',
                // sugerirBloqueo: false,
                // amonestarUsuario: false,
                motivoAmonestacionBloqueo:'',
                numMensajePendiente:0,
                comentarioDenegar:'',
                chatActivo: false,
                amonestaUsuario: false,
                sugiereBloqueo: false,
                mensaje: "",
                uidDestino: "",
                correoDestino: "string",
                codRecargaTipo: 0,
                codEntidadBancariaOrigen: 0,
                codSeguridad: '',
                mensajeID: '',
        }

        const [ estadoBotonPintar, setEstadoBotonPintar ] = useState(50)
        const [ recargas, setRecargas ] = useState([]);
        const [ recarga, setRecarga ] = useState(recargaDefault);
        const [ spinner, mostrarSpinner, ocultarSpinner ] = useSpinner();
        const [ isOpenObtenerRecarga, openModalObtenerRecarga, closeModalObtenerRecarga ] = useModal();
        const [ isOpenModalDenegar, openModalDenegar, closeModalDenegar ] = useModal()
        const [ bancos, setBancos ] = useState([]);
        const [ fechaInicioRecarga, setFechaInicioRecarga ] = useState()
        const [ fechaFinRecarga, setFechaFinRecarga ] = useState()
        const [ nroOperacionValido, setNroOperacionValido ] = useState(false)
        const [ loading, setLoading ] = useState(false);
        const [ bancoOrigen, setBancoOrigen ] = useState([]);
        const [ medioOrigen, setMedioOrigen ] = useState([]);

        useEffect(() => {
            listarEntidadesBancarias();
        }, []);

        useEffect(()=>{
            validarNroOperacion()
        },[recarga.numeroOperacionOCR])


        const listarRecargas = async (FechaInicio,FechaFin,estado) => {
            setFechaInicioRecarga(FechaInicio)
            setFechaFinRecarga(FechaFin)
            setEstadoBotonPintar(estado)
            mostrarSpinner();
            const response = await AuthFetchRecharge('/Recharge/listRechargeWeb?' + new URLSearchParams({
                fechaInicio:formatDate(FechaInicio,23) || new Date().toDateString() ,
                fechaFin:formatDate(FechaFin,23) || new Date().toDateString(),
                codEstado: estado == undefined ? 50 : estado,
            }), {
                method: 'GET'
            })

            if (response.isValid) {
                setRecargas(response.content)
            } else {
                notify('Hubo un problema al listar las recargas', 'error')
            }
            ocultarSpinner()
        }

        const listarEntidadesBancarias = async ()=>{
            const response = await AuthFetchRecharge(`/Recharge/banksDestiny`, {
                method: 'GET',
            })
            if(response.isValid){
                setBancos(response.content)
            }else{
                notify(response.content, 'error');
            }
        }

        const obtenerRecarga = async (codPeticion, abrirModal=true) => {
            setLoading(true)
            const response = await AuthFetchRecharge(`/Recharge/detail/${codPeticion}`, {
                method: 'GET',
            })
            
            if (response.isValid === true){
                const respuesta = response.content
                for (const key in respuesta){
                    if(key === 'fechaOCR'){
                        editarValorRecarga(key ,formatDate(new Date()) + ' ' + obtenerHoraActual())
                    }
                    else{
                        editarValorRecarga(key , respuesta[key])
                    }
                }
                editarValorRecarga('codSeguridad', '')

                
                setFotoRecarga(`${urlMinio}/Archivo/verImagen?NombreCarpeta=${response.content.nomCarpetaVoucher}&NombreImagen=${response.content.nomVoucher}`);
                if (abrirModal){
                    asignarAtencion(codPeticion)
                }
            }else{
                notify('No se pudo obtener los detalles de la Recarga','error')
                setRecarga(recargaDefault)
            }
            if (abrirModal){
                openModalObtenerRecarga()
            }
            setLoading(false)
        }

        const aceptarRecarga = async () =>{

            if(recarga.montoOCR == 0 || recarga.montoOCR == ""){
                notify('El monto no puede ser vacío o 0' , 'error')
                return; 
            }
            if(recarga.codEntidadBancariaCuenta == 0){
                notify("Debe seleccionar un banco","error")
                return;
            }
            if(recarga.numeroOperacionOCR == 0 || recarga.numeroOperacionOCR == "" ) {
                notify('El número de Operación no puede ser vacío o 0' , 'error')
                return;
            }
            if(recarga.montoOCR > 50){
                notify("Las recargas no pueden ser mayor a S/50","warning")
                return;
            }

            mostrarSpinner()
            const response = await AuthFetchRecharge(`/Recharge/rechargeUser`, {
                method: 'POST',
                    body: JSON.stringify({
                        uidDestino: recarga.uid,
                        montoVoucher: recarga.montoOCR,
                        codPeticion: recarga.codPeticion,
                        fechaOperacion: recarga.fechaOCR,
                        codEmpresaEntidadBancaria: recarga.codEntidadBancariaCuenta,
                        nroOperacion: recarga.numeroOperacionOCR,
                        codRecargaTipo: recarga.codRecargaTipo,
                        codEntidadBancariaOrigen: recarga.codEntidadBancariaOrigen,
                        codSeguridad: recarga.codSeguridad,
                        mensajeID: recarga.mensajeID
                    }),
            })
                ocultarSpinner()
                listarRecargas(fechaInicioRecarga,fechaFinRecarga,50)
                notify(response.isValid ? 'La recarga se realizó correctamente' : "BD:" +  response.exceptions[0].description, response.isValid ? 'success' : 'error')
                if(response.isValid){
                    setEstadoBotonPintar(50)
                    closeModalObtenerRecarga();
                }
        }
        
        const rechazarRecarga = async () =>{
            if(recarga.comentarioDenegar == ''){
                notify('Debe ingresar un comentario válido', 'error') 
                return
            }

            mostrarSpinner()
            const response = await AuthFetchRecharge(`/Recharge/cancelRecharge`, {
                method: 'POST',
                body: JSON.stringify({
                    uidDestino: recarga.uid,
                    monto: recarga.montoOCR,
                    codPeticion: recarga.codPeticion,
                    correoDestino: recarga.correoPrincipal,
                    comentario: recarga.comentarioDenegar,
                    chatActivo: recarga.chatActivo,
                    amonestaUsuario: recarga.amonestaUsuario || false,
                    sugiereBloqueo: recarga.sugiereBloqueo || false,
                    mensaje: recarga.motivoAmonestacionBloqueo || recarga.comentarioDenegar,
                }),
            })

            if (response.isValid){
                notify(response.content,'success');
                setEstadoBotonPintar(50)
                closeModalDenegar()
                closeModalObtenerRecarga()
                listarRecargas(fechaInicioRecarga,fechaFinRecarga,50)
            }else{
                notify(response.exceptions[0].description, 'error')
            }
            ocultarSpinner()
        }
        
        const editarValorRecarga = (key, value) =>{
            setRecarga(recarga => {
                return {
                    ...recarga,
                    [key]: value
                }
            });
        }

        const asignarAtencion = async (codPeticion) =>{
            const response = await AuthFetchRecharge('/Recharge/assing', {
                method: 'POST',
                body: JSON.stringify({
                    codRecarga: codPeticion ,
                    uidAsignado: stateUser.uid || ""
                })
            })
        }

        const validarNroOperacion = async ()=>{
            if(recarga.numeroOperacionOCR == '' || recarga.numeroOperacionOCR == 0){
                return; 
            }
            
            const response = await AuthFetchRecharge('/Recharge/validate', {
                method: 'POST',
                body: JSON.stringify({
                    nroOperacion: recarga.numeroOperacionOCR || 0
                })
            })

            setNroOperacionValido(response)

        }

        const listarBancoOrigen = async () => {
            try{
                const response = await AuthFetchRecharge('/Recharge/banksOrigen', {
                    method: 'GET',
                })
                !response.isValid && notify(response.exceptions[0].description, 'error')
                setBancoOrigen(response.isValid ? response.content : [])
            }
            catch(error){
                setBancoOrigen([]);
                notify('Ocurrió un error en el servicio', 'error');
                console.log('Error → ',error)
            }
        }

        const listarMedioOrigen = async () => {
            try{
                const response = await AuthFetchRecharge('/Recharge/typeRecharge', {
                    method: 'GET',
                })
                !response.isValid && notify(response.exceptions[0].description, 'error')
                setMedioOrigen(response.isValid ? response.content : [])
            }
            catch(error){
                setMedioOrigen([]);
                notify('Ocurrió un error en el servicio', 'error');
                console.log('Error → ',error)
            }
        }

        return {
            recargas,
            listarRecargas,
            recarga,
            setRecarga,
            spinner,
            isOpenObtenerRecarga,
            closeModalObtenerRecarga,
            editarValorRecarga,
            obtenerRecarga,
            estadoBotonPintar,
            setEstadoBotonPintar,
            aceptarRecarga,
            rechazarRecarga,
            isOpenModalDenegar,
            openModalDenegar,
            closeModalDenegar,
            bancos,
            fotoRecarga,
            listarEntidadesBancarias,
            validarNroOperacion,
            nroOperacionValido,
            loading,
            listarMedioOrigen,
            medioOrigen,
            listarBancoOrigen,
            bancoOrigen

        };
    }